export default "__VITE_ASSET__BtDxKnaZ__"